<template>
  <div class="row roomy position-relative container-scene">
    <div class="content column-12 laptop:column-6 padding-top-6xl padding-bottom-3xl display-flex flex-column flex-align-center">
      <div class="margin-bottom-xl">
        <h2 class="text-capitalize">
          <i :class="[`fa-${selectedFamily} ${getStyleTag(selectedStyle)} fa-${categoryIcon} fa-lg margin-right-3xs`]" />
          {{ category }} Icons
        </h2>
        <p class="margin-y-xl">{{ description }}</p>

        <div>
          <span
            class="tag white rounded margin-right-md margin-bottom-md"
            style="--tag-background: var(--white)"
          >
            {{ totalIconCount }} Icons
          </span>

          <span
            v-if="newIconCount > 0"
            class="tag white rounded margin-right-md margin-bottom-md"
            style="--tag-background: var(--white)"
          >
            {{ newIconCount }} New
          </span>

          <span
            v-if="freeIconCount > 0"
            class="tag white rounded margin-right-md margin-bottom-md"
            style="--tag-background: var(--white)"
          >
            {{ freeIconCount }} Free
          </span>
        </div>

        <wa-carbon-ad class="margin-top-xl" />
      </div>
    </div>
    <div class="scene position-absolute">
      <div
        v-if="state"
        class="display-none laptop:display-block"
      >
        <div
          v-for="icon in iconList.icons"
          :key="icon.id"
          :class="`${icon.extraClass} display-flex flex-items-center flex-content-center padding-sm position-absolute with-border-radius`"
          style="aspect-ratio: 1 / 1"
          :style="icon.cssStyle"
        >
          <i
            :class="`fa-fw ${getStyleTag(icon.style)} fa-${icon.icon} ${icon.extraIconClass}`"
            :style="icon.cssIconStyle"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { createWidgetMixin } from 'vue-instantsearch'
  import { connectHits } from 'instantsearch.js/es/connectors'
  import { FAStyleIds } from '@fortawesome-internal-tools/fontawesome-icons/canonical' // eslint-disable-line import/no-unresolved
  import { FA5StyleIds } from '@fortawesome-internal-tools/fontawesome-icons/legacy' // eslint-disable-line import/no-unresolved

  const headerLayouts = require('./headerLayouts.json')

  export default {
    name: 'CategoryHeader',

    mixins: [createWidgetMixin({ connector: connectHits })],

    props: {
      category: {
        type: String
      },
      description: {
        type: String
      },
      categoryIcon: {
        type: String
      },
      version: {
        type: Number
      },
      selectedFamily: {
        type: String
      },
      selectedStyle: {
        type: String
      }
    },

    data() {
      return {
        categoryChanged: true,
        headIcons: [],
        colors: null,
        v6styles: FAStyleIds,
        v5styles: FA5StyleIds,
        iconsLoaded: false,
        excludeIcons: ['hand-middle-finger']
      }
    },

    computed: {
      totalIconCount() {
        return this.state ? this.state.hits.length : 0
      },

      newIconCount() {
        return this.state ? this.state.hits.filter((i) => i.is_new_in_v6 == true).length : 0
      },

      freeIconCount() {
        return this.state ? this.state.hits.filter((i) => i.is_free == true).length : 0
      },

      iconList() {
        return this.headIcons
      }
    },

    watch: {
      'category'() {
        this.categoryChanged = true
      },

      'state.hits'(oldHits, newHits) {
        if (!this.iconsLoaded) {
          // Handle initial load of header icons
          this.headIcons = this.loadRandomIcons()
          this.iconsLoaded = true
        } else if (this.categoryChanged) {
          if (!this.iconsLoaded || (newHits && newHits.length !== oldHits.length)) {
            this.headIcons = this.loadRandomIcons()
            this.categoryChanged = false
          }
        }
      }
    },

    methods: {
      loadRandomIcons() {
        const iconList = []
        const headIcons = this.getRandomItem(headerLayouts)
        headIcons.icons.forEach((headIcon) => {
          let rndIcon = ''
          let count = 0

          do {
            rndIcon = this.getRandomIcon()
            count++
          } while (this.excludeIcons.includes(rndIcon) || (iconList.includes(rndIcon) && count < 20))

          headIcon.icon = rndIcon
          iconList.push(rndIcon)

          if (headIcon.style == 'random') {
            headIcon.style = this.getRandomStyle()
          }

          // v5 hack - switch thin to light. Some layouts in headerLayouts.json include style of thin
          if (this.version == 5 && headIcon.style == 'thin') {
            headIcon.style = 'light'
          }
        })

        return headIcons
      },

      getRandomIcon() {
        if (this.state && this.state.hits.length > 0) {
          const result = this.getRandomItem(this.state.hits)
          return result.name
        } else {
          return ''
        }
      },

      getRandomStyle() {
        const styles = (this.version === 5 ? this.v5styles : this.v6styles).filter((s) => s !== 'brands')
        return this.getRandomItem(styles)
      },

      getRandomItem(items) {
        return items[Math.floor(Math.random() * items.length)]
      },

      getStyleTag(style) {
        return this.version === 5 ? `fa${style.charAt(0)}` : `fa-${style}`
      }
    }
  }
</script>
